module.exports = __webpack_public_path__ + "6aca01118b9841696d560b093319b860.MP3";